import React, { useState, useEffect } from 'react';
import '../styles/Library.css';
import pic1 from "../sciencelabs/library (1).png";
import pic2 from "../sciencelabs/library (2).png";
import pic3 from "../sciencelabs/library (3).png";
import pic4 from "../assets/hindi (1).png";

const Library = () => {
  const [currentImageSlide, setCurrentImageSlide] = useState(0);
  const [autoPlay, setAutoPlay] = useState(true);

  // Slider Images Only
  const sliderImages = [
    pic1,
    pic2,
    pic3,
  ];

  // Library Facilities
  const facilities = [
    {
      id: 1,
      name: 'Reading Room',
      description: 'A quiet and comfortable space designed for focused reading and studying. Equipped with ergonomic seating and proper lighting to enhance the reading experience.',
      icon: pic4,
    },
    {
      id: 2,
      name: 'Book Collection',
      description: 'Extensive collection of books across various genres including fiction, non-fiction, reference books, textbooks, and periodicals. Regularly updated with new arrivals.',
      icon: pic4,
    },
    {
      id: 3,
      name: 'Study Area',
      description: 'Dedicated study zones with individual desks and group study tables. Perfect for exam preparation, project work, and collaborative learning activities.',
      icon: pic4,
    }
  ];

  // Library Timings
  const timings = [
    { day: 'Monday - Friday', time: '8:00 AM - 4:00 PM' },
    { day: 'Saturday', time: '9:00 AM - 1:00 PM' },
    { day: 'Sunday', time: 'Closed' }
  ];

  // Library Rules
  const rules = [
    'Maintain complete silence in the library premises',
    'Handle books with care and return them on time',
    'Keep your library card with you at all times',
    'No food or beverages allowed inside the library',
    'Mobile phones must be kept on silent mode',
    'Students must sign in the register before entering',
    'Maximum 2 books can be issued at a time for 14 days',
    'Lost or damaged books must be replaced or paid for'
  ];

  // Auto-play slider
  useEffect(() => {
    if (!autoPlay) return;
    
    const interval = setInterval(() => {
      setCurrentImageSlide((prev) => (prev + 1) % sliderImages.length);
    }, 5000);

    return () => clearInterval(interval);
  }, [autoPlay, sliderImages.length]);

  const nextSlide = () => {
    setAutoPlay(false);
    setCurrentImageSlide((prev) => (prev + 1) % sliderImages.length);
    setTimeout(() => setAutoPlay(true), 5000);
  };

  const prevSlide = () => {
    setAutoPlay(false);
    setCurrentImageSlide((prev) => (prev - 1 + sliderImages.length) % sliderImages.length);
    setTimeout(() => setAutoPlay(true), 5000);
  };

  return (
    <>
      {/* Library Banner */}
      <div className="lib-banner-section">
        <div className="lib-banner-overlay"></div>
        <div className="lib-banner-content">
          <h1 className="lib-banner-title">LIBRARY</h1>
        </div>
      </div>

      {/* Main Library Section */}
      <section className="lib-main-section" id="lib-main">
        {/* About & Slider Container - Side by Side */}
        <div className="lib-about-slider-container">
          {/* Left - About Section */}
          <div className="lib-about-wrapper">
            <div className="lib-description-block">
              <h2 className="lib-section-title">About Our <span className="lib-title-highlight">Library</span></h2>
              <p className="lib-description-text">
                Our school library is a treasure trove of knowledge and learning resources. It serves as a hub for 
                academic excellence, fostering reading habits and research skills among students. With a carefully 
                curated collection of books, periodicals, and digital resources, we provide an enriching environment 
                that supports both curriculum-based learning and personal growth. The library is not just a repository 
                of books, but a vibrant learning center that encourages exploration, creativity, and lifelong learning.
              </p>
            </div>
          </div>

          {/* Right - Image Slider */}
          <div className="lib-slider-wrapper">
            <div className="lib-image-carousel">
              {/* Image Display */}
              <div className="lib-image-display">
                {sliderImages.map((image, index) => (
                  <div 
                    key={index}
                    className={`lib-image-item ${index === currentImageSlide ? 'lib-image-active' : ''}`}
                  >
                    <img src={image} alt={`Library ${index + 1}`} />
                  </div>
                ))}
              </div>

              {/* Navigation Arrows */}
              <button 
                className="lib-image-nav-btn lib-image-nav-prev"
                onClick={prevSlide}
                aria-label="Previous image"
              >
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                  <polyline points="15 18 9 12 15 6"></polyline>
                </svg>
              </button>

              <button 
                className="lib-image-nav-btn lib-image-nav-next"
                onClick={nextSlide}
                aria-label="Next image"
              >
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                  <polyline points="9 18 15 12 9 6"></polyline>
                </svg>
              </button>
            </div>
          </div>
        </div>

        {/* Library Facilities Section */}
        <div className="lib-content-section">
          <div className="lib-facilities-container">
            <h3 className="lib-facilities-heading">Our <span className="lib-heading-accent">Facilities</span></h3>
            
            <div className="lib-facilities-grid">
              {facilities.map((facility) => (
                <div 
                  key={facility.id} 
                  className="lib-facility-card"
                >
                  <div className="lib-card-icon">
                    <img src={facility.icon} alt={facility.name} className="lib-item-icon"/>
                  </div>
                  <h4 className="lib-card-title">{facility.name}</h4>
                  <p className="lib-card-desc">{facility.description}</p>
                </div>
              ))}
            </div>
          </div>

          {/* Library Timings & Rules Section */}
          <div className="lib-info-section">
            <div className="lib-info-grid">
              {/* Timings Card */}
              <div className="lib-info-card lib-timings-card">
                <div className="lib-info-header">
                  <svg className="lib-info-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                    <circle cx="12" cy="12" r="10"></circle>
                    <polyline points="12 6 12 12 16 14"></polyline>
                  </svg>
                  <h3 className="lib-info-title">Library Timings</h3>
                </div>
                <div className="lib-timings-list">
                  {timings.map((timing, index) => (
                    <div key={index} className="lib-timing-item">
                      <span className="lib-timing-day">{timing.day}</span>
                      <span className="lib-timing-time">{timing.time}</span>
                    </div>
                  ))}
                </div>
              </div>

              {/* Rules Card */}
              <div className="lib-info-card lib-rules-card">
                <div className="lib-info-header">
                  <svg className="lib-info-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                    <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"></path>
                    <polyline points="14 2 14 8 20 8"></polyline>
                    <line x1="16" y1="13" x2="8" y2="13"></line>
                    <line x1="16" y1="17" x2="8" y2="17"></line>
                    <polyline points="10 9 9 9 8 9"></polyline>
                  </svg>
                  <h3 className="lib-info-title">Library Rules</h3>
                </div>
                <ul className="lib-rules-list">
                  {rules.map((rule, index) => (
                    <li key={index} className="lib-rule-item">{rule}</li>
                  ))}
                </ul>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default Library;